import router from '@/router'

export default function navigateBack(step = -1) {
  // 模板中使用 @click="$navigateBack" 时，Vue 会把事件对象作为第一个参数传入。
  // 这里统一兜底成返回上一页，避免 router.go(MouseEvent) 报错。
  const normalizedStep =
    typeof step === 'number'
      ? step
      : step && typeof step === 'object' && step.type
        ? -1
        : -1

  // 在 PC 适配（iframe）环境下，初次加载深链接时，history.length 可能 > 1，
  // 但无法有效返回上一页。此处放宽阈值，确保能回到首页。
  const isInIframe = window.top !== window
  const historyLen = window.history.length || 0
  const minimalBackDepth = isInIframe ? 2 : 1

  if (normalizedStep >= 0 || historyLen <= minimalBackDepth) {
    router.push('/')
    return false
  }
  router.go(normalizedStep)
}
